import React from 'react';
import Loader from '../../../../common/loader';
import language from '../../../../assets/languages/language';
import { renderHTMLContent } from '../../../../common/function';

function ViewNormalAnswer(props) {
  const { loaderCSS, userChoice, selectedCaseQuestionData } = props;
  const currentQuestionChoice =
    userChoice &&
    (userChoice[selectedCaseQuestionData.id] === selectedCaseQuestionData.answer ||
      userChoice[selectedCaseQuestionData.id] === `choice_${selectedCaseQuestionData.answer}`);

  const getFormattedAnswer = (answer) => {
    const choices = {
      a: 'A',
      b: 'B',
      c: 'C',
      d: 'D',
      e: 'E',
    };

    const formattedAnswer = choices[answer] || ''; // Get the corresponding letter

    return `${formattedAnswer}.`;
  };
  const answerText =
    selectedCaseQuestionData && selectedCaseQuestionData.answer
      ? `${language.LC().THE_CORRECT_ANSWER_IS} ${getFormattedAnswer(selectedCaseQuestionData.answer, true)}`
      : '';
  return (
    <div className='card show_block'>
      <div className={'main_loader ' + loaderCSS}>
        <div className='loader-mid'>
          <div className='card-block-loader'>
            <Loader />
          </div>
        </div>
      </div>
      <div
        className={`card-header highlight_finish_text ${currentQuestionChoice
          ? 'text_success-cbt'
          : !userChoice[selectedCaseQuestionData.id]
            ? 'text_unAttempted-cbt'
            : 'text_failure-cbt'
          }`}
      >
        {currentQuestionChoice
          ? `${language.LC().Correct}`
          : !userChoice[selectedCaseQuestionData.id]
            ? `${language.LC().NOT_ATTEMPTED}`
            : `${language.LC().Incorrect}`}
      </div>
      <div className='card-block'>
        {renderHTMLContent(
          selectedCaseQuestionData && selectedCaseQuestionData.answer
            ? `${language.LC().THE_CORRECT_ANSWER_IS} ${selectedCaseQuestionData.answer === 'choice_a' || selectedCaseQuestionData.answer === 'a'
              ? `<strong>${language.LC().A}.</strong>`
              : selectedCaseQuestionData.answer === 'choice_b' || selectedCaseQuestionData.answer === 'b'
                ? `<strong>${language.LC().B}.</strong>`
                : selectedCaseQuestionData.answer === 'choice_c' || selectedCaseQuestionData.answer === 'c'
                  ? `<strong>${language.LC().C}.</strong>`
                  : ''
            }`
            : '',
          'p',
          'answer_text'
        )}
        {renderHTMLContent(
          selectedCaseQuestionData && selectedCaseQuestionData.explanation
            ? selectedCaseQuestionData.explanation
            : "",
          "p",
          "view_questionhtml",
          { contentEditable: false }
        )}
      </div>
    </div>
  );
}

export default ViewNormalAnswer;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/FinishTest/ViewNormalAnswer.jsx